import {
  type FeatureFlag,
  useFlags,
} from '@terminal/stores/use-flags/useFlags';

export const PRICE_HISTORY_V2_FEATURE_FLAG: FeatureFlag =
  'DATA-1542-price-history-v2';

/**
 * Non-reactive snapshot for the service/fetch layer, which runs outside React
 * (query functions, query-option factories). Do NOT call this at React render
 * time — it reads `getState()` without subscribing, so components won't
 * re-render when the flag toggles. Use {@link useIsPriceHistoryV2Enabled} in
 * hooks/components instead.
 */
export const isPriceHistoryV2Enabled = () =>
  useFlags.getState().getFeatureFlagState(PRICE_HISTORY_V2_FEATURE_FLAG);

/**
 * Reactive read for React render. Subscribes to the flag store so a mid-session
 * flag toggle re-renders the component, updating the price query keys and venue
 * gating in lockstep with the fetch-time {@link isPriceHistoryV2Enabled} read.
 */
export const useIsPriceHistoryV2Enabled = () =>
  useFlags(state => state.getFeatureFlagState(PRICE_HISTORY_V2_FEATURE_FLAG));
